import MultipleSelect from "../../../Components/CluppForms/MultipleSelect";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const OtherInsuranceQuestions = ({ state, setState, field }) => {
  const options = [
    {
      id: `Me ofrecen un mejor precio`,
      label: `Me ofrecen un mejor precio`,
      value: `Me ofrecen un mejor precio`,
    },
    {
      id: "Me ofrecen un mejor servicio",
      label: "Me ofrecen un mejor servicio",
      value: "Me ofrecen un mejor servicio",
    },
    { id: "Otro", label: "Otro (escribe tu razón)", value: "" },
  ];
  
  return (
    <>
      <TitleHeaders
        title={"¿Qué te ofrece el otro seguro?"}
        subtitle={"Por favor, selecciona una de las siguientes opciones."}
        isRequired={true}
      />

      <MultipleSelect
        options={options}
        state={state}
        setState={setState}
        field={field}
        isMultiple={false}
        haveOtherTextField={true}
      />
    </>
  );
};

export default OtherInsuranceQuestions;
